import type { CategoryOptionFilter } from 'graphql-ts-types';

import type { ArticleSortOption } from 'common/enums/SortOption';
import {
  createOptionsParamValue,
  createRangeMaxParamName,
  createRangeMinParamName,
} from '../components/ClearAllFiltersButton';
import type { Filter } from '../types/SortAndFilter';
import type { QueryParams } from './url';

const getSelectedOptionsParamValue = (filter: CategoryOptionFilter) =>
  createOptionsParamValue(
    filter.options.filter(option => option.selected).map(option => option.key)
  );

const generateFilterQueryParam = (filter: Filter): QueryParams => {
  const filterKey = filter.key;
  if ('options' in filter) {
    return {
      [filterKey]: getSelectedOptionsParamValue(filter),
    };
  }

  return {
    [createRangeMinParamName(filterKey)]: filter.selectedMin !== null ? filter.selectedMin : '',
    [createRangeMaxParamName(filterKey)]: filter.selectedMax !== null ? filter.selectedMax : '',
  };
};

export const getInitialQueryParams = (
  filters: Filter[],
  order?: ArticleSortOption
): QueryParams => {
  const filtersQueryParams = filters.reduce(
    (acc, filter) => ({
      ...acc,
      ...generateFilterQueryParam(filter),
    }),
    {}
  );

  return {
    page: '',
    ...(order && { order }),
    ...filtersQueryParams,
  };
};
